/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_FailedInputs */

const en_us2_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the options.`)
};

const pt_br2_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não deu para buscar as opções.`)
};

const es_419_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron cargar las opciones.`)
};

const pt_pt2_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar as opções.`)
};

const fr_fr2_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger les options.`)
};

const de_de2_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Optionen konnten nicht geladen werden.`)
};

const it_it2_swap_failed = /** @type {(inputs: Swap_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile caricare le opzioni.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the options." |
*
* @param {Swap_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_failed = /** @type {((inputs?: Swap_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_failed(inputs)
	if (locale === "es-419") return es_419_swap_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_failed(inputs)
	if (locale === "de-DE") return de_de2_swap_failed(inputs)
	if (locale === "it-IT") return it_it2_swap_failed(inputs)
	return en_us2_swap_failed(inputs)
});
export { swap_failed as "swap.failed" }